import { createElement } from "react";
import { Root, createRoot } from "react-dom/client";

export function fetcher(url, body) {
  return fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
}

export const fetch_retry = async (url, body, n, delay = 1000) => {
  try {
    return await fetcher(url, body)
      .then((res) => {
        if (!res.ok) {
          throw new Error();
        }

        return res;
      })
      .catch((err) => {
        throw new Error();
      });
  } catch (err) {
    console.log("retry catch", n, url);
    if (n === 1) throw err;

    // 遅延を追加する
    await new Promise((resolve) => setTimeout(resolve, delay));

    // 次のリトライを実行
    return await fetch_retry(url, body, n - 1, delay * 2); // 遅延時間を2倍
  }
};

export function idMaker(N) {
  const S = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(Array(N))
    .map(() => S[Math.floor(Math.random() * S.length)])
    .join("");
}

export const uidFactory = (min: number, max: number) => {
  return Math.floor(Math.random() * (max + 1 - min)) + min;
};

export const getUrlParam = (i) => {
  const pathname = location.pathname;
  return pathname.split("/")[i + 1];
};

export function zeroPadding(NUM, LEN) {
  // NUM=値 LEN=桁数
  if (String(NUM).length > LEN) {
    LEN = String(NUM).length;
  }
  return (Array(LEN).join("0") + NUM).slice(-LEN);
}

export function formatDate(enableZeroPadding, date) {
  const dt = date ? new Date(date) : new Date();
  const y = dt.getFullYear();
  const m = enableZeroPadding
    ? zeroPadding(dt.getMonth() + 1, 2)
    : dt.getMonth() + 1;
  const d = enableZeroPadding ? zeroPadding(dt.getDate(), 2) : dt.getDate();
  const hh = enableZeroPadding ? zeroPadding(dt.getHours(), 2) : dt.getHours();
  const mm = enableZeroPadding
    ? zeroPadding(dt.getMinutes(), 2)
    : dt.getMinutes();
  const ss = enableZeroPadding
    ? zeroPadding(dt.getSeconds(), 2)
    : dt.getSeconds();

  return {
    y,
    m,
    d,
    hh,
    mm,
    ss,
  };
}

export const setImgPath = (fileName) => {
  return process.env === "development" ? `/${fileName}` : `/ea/${fileName}`;
};

export const toggleBodyScroll = (enable: boolean) => {
  if (enable) {
    document.body.classList.add("forbiddenScroll");
  } else {
    document.body.classList.remove("forbiddenScroll");
  }
};

export const checkBuild = (text) => {
  if (process.env.NODE_ENV === "production") {
    throw new Error(`checkBuild ${text}`);
  }
};

export const alphabets = Array.from({ length: 26 }, (_, i) =>
  String.fromCharCode(97 + i).toUpperCase()
);

export const setExcludeStr = (str: string) => {
  if (location.href.match("/exclude/")) {
    return `/exclude${str}`;
  } else {
    return str;
  }
};

export const renderToDOM = (
  id: string,
  comp: React.FC,
  args = {},
  root: Root | null = null
): Root | undefined => {
  const container = document.getElementById(id);

  let _root = root;

  if (container) {
    if (!_root) {
      _root = createRoot(container);
    }

    _root.render(createElement(comp, args));
    return _root;
  }
};

export const getLocalStorageObj = (storageKey, objKey) => {
  // localStorageないとき → null
  // 対象のsympoIdの情報がある時 → 配列
  // 対象のsympoIdの情報がない時 → false

  try {
    const obj = JSON.parse(localStorage.getItem(storageKey));
    if (obj === null) return null;
    return obj[objKey] || false;
  } catch (e) {
    return null;
  }
};

export const getSympoUserInfo = (symposiumId) => {
  return getLocalStorageObj("userInfo", symposiumId);
};

export const splitUserInfo = (userInfoValue) => {
  const commaSeparatedParts = userInfoValue.split(",");
  // 2つ目のカンマまでの文字列を配列に格納
  const result = [commaSeparatedParts[0], commaSeparatedParts[1]];

  // 2つ目以降の文字列を結合
  const combinedString = commaSeparatedParts.slice(2).join(",");

  const parsedValue = JSON.parse(combinedString);
  result.push(parsedValue);

  return result;
};

export const createDisplayUserName = (name, prohibit, maxLength = 30) => {
  let str = name;
  if (prohibit) {
    str = str.replace(/./g, "-");
  }

  return str.length > maxLength ? str.slice(0, maxLength) + "..." : str;
};